export const firebaseConfig = {
  apiKey: 'AIzaSyDZLyOkbW0KrOwpA6anog3nhgKki3GbC0o',
  authDomain: 'third-place-279322.firebaseapp.com',
  projectId: 'third-place-279322',
};
